//
import React, { useContext } from 'react';
import { getTrackerData } from 'localmed-tracker';

import { SCREENER_STATUSES } from './constants';

import {
  encodeData,
  setSessionStorageItem,
  decodeData,
  getSessionStorageItem,
} from '../../utils/session/utils';
import { savePrefillToken, getPrefillToken } from '../../utils/session/prefillToken';
import { UniversalContext, RENDER_PHASE } from '../../../_universal';

const DEFAULT_SESSION_NAME = 'lm_widget_settings';

export const DEFAULT_CONTEXT = {
  screenerStatus: SCREENER_STATUSES.NOT_SCREENED,
  // eslint-disable-next-line no-unused-vars
  setScreenerStatus: status => {},
  widgetSettings: {},
  // eslint-disable-next-line no-unused-vars
  setWidgetSettings: widgetSettings => {},
  prefillToken: undefined,
  // eslint-disable-next-line no-unused-vars
  setPrefillToken: token => {},
  trackerData: {},
  // eslint-disable-next-line no-unused-vars
  setTrackerData: data => {},
};

export const SchedulingSessionStateContext = React.createContext(DEFAULT_CONTEXT);

export const useSchedulingSessionState = ({
  initialWidgetSettings,
  initialPrefillToken,
  initialTrackerData,
} = {}) => {
  const [status, setStatus] = React.useState(SCREENER_STATUSES.NOT_SCREENED);
  const [widgetSettings, setWidgetSettingsState] = React.useState(
    () =>
      initialWidgetSettings || {
        ...decodeData(getSessionStorageItem(DEFAULT_SESSION_NAME)),
      }
  );

  const [prefillToken, setPrefillTokenState] = React.useState(
    () => initialPrefillToken || getPrefillToken()
  );

  const [trackerData, setTrackerDataState] = React.useState(
    () => initialTrackerData || getTrackerData()
  );
  const universalContext = useContext(UniversalContext);

  const setScreenerStatus = React.useCallback(updatedStatus => {
    setStatus(updatedStatus);
  }, []);

  const setWidgetSettings = React.useCallback(
    settings => {
      setWidgetSettingsState(settings);
      if (universalContext.renderPhase !== RENDER_PHASE.BEFORE_SERVER_RENDER) {
        setSessionStorageItem(DEFAULT_SESSION_NAME, encodeData(settings));
      }
    },
    [universalContext]
  );

  const setPrefillToken = React.useCallback(token => {
    setPrefillTokenState(token);
    if (typeof token !== 'undefined') {
      savePrefillToken(token);
    }
  }, []);

  const setTrackerData = React.useCallback(updatedTrackerData => {
    setTrackerDataState(updatedTrackerData);
  }, []);

  return {
    // PatientScreener
    screenerStatus: status,
    setScreenerStatus,
    // WidgetSettings
    widgetSettings,
    setWidgetSettings,
    // PrefillToken
    prefillToken,
    setPrefillToken,
    // TrackerData
    trackerData,
    setTrackerData,
  };
};
